/**
 * Tells the shop's owner when its AppBay subscription is about to end, or has.
 * Only the people who run the shop see it (they can change its settings); a
 * cashier has nothing to do about it. Dates only - the price is between the
 * shop and AppBay, not something to put on a till screen.
 */
import { useAuth } from '../state/auth.js';
import { useI18n, useT } from '../i18n/index.js';

/** A week's notice is plenty in a shop; the owner of the system sees it sooner. */
const WARN_DAYS = 7;

export function SubscriptionNotice() {
  const t = useT();
  const { lang } = useI18n();
  const { can, user, subscription } = useAuth();
  if (!user || !can('settings.edit') || !subscription) return null;
  const { status, paidUntil, daysLeft } = subscription;
  const soon = status === 'due_soon' && daysLeft !== null && daysLeft <= WARN_DAYS;
  if (!(soon || status === 'overdue' || status === 'unpaid')) return null;

  const date = paidUntil
    ? new Date(`${paidUntil}T12:00:00`).toLocaleDateString(lang === 'ar' ? 'ar-PS-u-nu-latn' : 'en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })
    : '';
  const text =
    status === 'unpaid' ? t('sub.unpaid') : status === 'overdue' ? t('sub.ended', { date }) : t('sub.endsOn', { date });
  const wa = `https://wa.me/970597579694?text=${encodeURIComponent(t('sub.waText'))}`;
  return (
    <div className={`${status === 'due_soon' ? 'note-warn' : 'note-danger'} till-alert`} role="status">
      <span>{text}</span>
      <a href={wa} target="_blank" rel="noopener">
        {t('sub.contact')}
      </a>
    </div>
  );
}
